import { IModalAttachment } from '../model/IModalAttachment.interface';

export function isModalAttachment(obj: unknown): obj is IModalAttachment {
    return !!obj && typeof obj === 'object' && 'file' in obj;
}
